export default {
  title01: "目前天氣",
  title02: "24小時",
  title03: "查看未來十日天氣預報",
  title04: "空氣質量指數",
  title05: "查看所有資訊",
  title06: "日出和日落",
  title07: "月相",
  title08: "下一次滿月",
  title09: "下一次新月",
  title10: "日",
  title11: "夜",
  title12: "日出",
  title13: "日落",
  title14: "月出",
  title15: "月落",
  title16: "來源",
  title17: "開始",
  title18: "結束",
  title19: "使用目前位置",
  title20: "搜索城市",
  title21: "體感溫度",
  title22: "陰影下的體感溫度",
  title23: "現在",
  title24: "今天",
  title25: "星期日",
  title26: "星期一",
  title27: "星期二",
  title28: "星期三",
  title29: "星期四",
  title30: "星期五",
  title31: "星期六",
  title32: "載入中...",
  title33: "現在",
  title34: "每小時",
  title35: "每日",
  title36: "日與月",
  title37: "空氣質素",
  title38: "請聯絡 : xlf550402@gmail.com",
  title39: "隱私協議",
  title40: "版權所有 © comfortweather.com 2020 - 2026. 保留所有權利",
  title41: "數據由",
  title42: "最高氣溫",
  title43: "最低氣溫",
  title44: "接受",
  title45: "感謝您使用 ComfortWeather！為了更好地保護您的合法權益，請在使用前仔細閱讀 ",
  title46: "隱私權政策",
  title47: " 。",
  title48: "提供",
  title49: "請聯絡 : xyjph123@gmail.com",
  title50: "版權所有 © 24hweather.com 2020 - 2026. 保留所有權利",
  title51: "感謝您使用 24hweather！為了更好地保護您的合法權益，請在使用前仔細閱讀 ",
  title52: "您的位置已改變。您想更新它嗎？",
  title53: "確認",
  title54: "取消",
  title55: "返回",
  title56: "新聞",
  title57: "正在更新天氣…",
  title58: "天氣已更新",
  title59: "看全部",
  title60: "版權所有 © mobi321.com 2020 - 2026. 保留所有權利",
  title61: "昨天",
  title62: "明天",
  title63: "查看未來十五日天氣預報",
  title64: "今天詳情",
  title65: "Rahu Kaal",
  title66: "生活指數",
  title67: "生活指數",
  title68: "未來7天Rahu Kala時間表",
  title69: "至",
  title70: "至",
  title71: "空氣質量指數",

  title102: "不易乾燥",
  title103: "乾燥速度慢",
  title104: "容易乾燥",
  title105: "乾燥速度快",
  title106: "乾燥速度非常快",

  title107: "不適合",
  title108: "體驗一般",
  title109: "適合水上活動",
  title110: "非常適合",
  title111: "完美條件",

  title112: "有利於健康",
  title113: "中性條件",
  title114: "風險略高",
  title115: "高風險",
  title116: "極高風險",

  title117: "不適合",
  title118: "稍微適合",
  title119: "適合戶外活動",
  title120: "非常適合",
  title121: "極佳條件",

  title122: "極度乾燥的天氣條件",
  title123: "可能出現乾燥",
  title124: "輕微乾燥",
  title125: "不太可能乾燥",
  title126: "極不可能乾燥",

  title127: "不建議洗車",
  title128: "尚可",
  title129: "適合洗車的一天",
  title130: "洗車條件非常好",
  title131: "理想洗車條件",
};
